import DestinationColumn from './DestinationColumn';
var Destination = /** @class */ (function () {
    function Destination(_a) {
        var id = _a.id, tableName = _a.tableName, columns = _a.columns;
        this.id = id;
        this.tableName = tableName;
        this.columns = columns;
    }
    Destination.fromJSON = function (json) {
        var _a = Object.assign({}, json), id = _a.id, tableName = _a.tableName, columns = _a.columns;
        if (typeof id !== 'string')
            throw new Error('id must be a string');
        if (typeof tableName !== 'string')
            throw new Error('tableName must be a string');
        if (typeof columns !== undefined && !Array.isArray(columns))
            throw new Error('columns must be an array');
        var _columns = columns.map(function (column) { return DestinationColumn.fromJSON(column); });
        return new Destination({
            id: id,
            tableName: tableName,
            columns: _columns,
        });
    };
    return Destination;
}());
export default Destination;
